import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStageAct = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_74_68)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M29.3334 70.6612L37.3334 41.3279H26.6667L34.6667 9.32788H56L42.6667 30.6612H56L29.3334 70.6612Z",
			stroke: "black",
			strokeWidth: 2.70833,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_74_68",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 64,
			height: 64,
			fill: "white",
			transform: "translate(8 8)"
		})
	}) })]
});
export default SvgIconStageAct;
